interface HasMoreItemsAttributes {
    totalData: number,
    dataPerBatch: number,
    page: number,

}

export default function hasMoreItems({totalData, dataPerBatch, page}: HasMoreItemsAttributes): boolean {
    return (totalData >= dataPerBatch * page);
}